export const Loading = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '40vh' }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style={{ maxWidth: '200px', height: 'auto' }}>
                <circle fill="#4E97FD" stroke="#4E97FD" strokeWidth="15" r="15" cx="40" cy="65">
                    <animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite"
                             begin="-.4"></animate>
                </circle>
                <circle fill="#4E97FD" stroke="#4E97FD" strokeWidth="15" r="15" cx="100" cy="65">
                    <animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite"
                             begin="-.2"></animate>
                </circle>
                <circle fill="#4E97FD" stroke="#4E97FD" strokeWidth="15" r="15" cx="160" cy="65">
                    <animate attributeName="cy" calcMode="spline" dur="2" values="65;135;65;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite"
                             begin="0"></animate>
                </circle>
            </svg>
        </div>
    );
}

export default Loading;